"use client";

import { useLingui } from "@lingui/react/macro";
import { UserIcon } from "@offstreetparking/design-system/icons/UserIcon";
import { useProductTracking } from "@offstreetparking/design-system/providers";
import { useRouter } from "next/navigation";
import { writeSignupPrefill } from "../../../../lib/signup-prefill";
import { useCompany } from "../../../../providers/company";
import { useParker } from "../../../../providers/parker";
import { routes } from "../../../../routes";
import { useKiosk } from "../../../providers/KioskProvider";
import { ConfirmationActionRow } from "./ConfirmationActionRow";

export const CreateAccountCard = ({
	checkoutEmail,
	publicIdentifier,
}: { checkoutEmail?: string; publicIdentifier?: string }) => {
	const { t } = useLingui();
	const { capture } = useProductTracking();
	const { isKiosk } = useKiosk();
	const { company: portalCompany } = useCompany();
	const optionalParkerAccounts = !!portalCompany?.isOptionalParkerAccountsEnabled;
	const { isLoggedIn, enabled } = useParker();
	const router = useRouter();

	if (!optionalParkerAccounts || !enabled || isLoggedIn || isKiosk) {
		return null;
	}

	return (
		<section aria-label={t`Save this permit`}>
			<ConfirmationActionRow
				icon={UserIcon}
				hasAccent
				title={t({
					message: "Save this permit",
					comment: "Title of the confirmation page row that invites a guest parker to create an account",
				})}
				subtitle={t`Access your permits anytime`}
				action={{
					label: t({
						message: "Create account",
						comment: "Button on the permit confirmation page linking to sign-up",
					}),
					onClick: () => {
						writeSignupPrefill({ email: checkoutEmail, connectPermitPublicIdentifier: publicIdentifier });
						capture(
							{
								feature: "optional_parker_accounts",
								action: "open",
								object: "button",
								context: "confirmation_page",
							},
							{},
						);
						router.push(routes.signup({ redirectTo: routes.permits(), source: "confirmation" }));
					},
				}}
			/>
		</section>
	);
};
